import Modals from "components/Modal";
import useDonationReport from "hook/reports/useDonationReport";
import { DONATION_ANALYTICS } from "navigation/routes";
import { Link } from "react-router-dom";
import { startCase } from 'lodash'
import Select from "components/innerComponents/Select";
import useDonationManagement from "hook/useDonationManagement";
import SelectBox from "components/common/Selects/SelectBox";
import MembershipEnhancedTable from "components/MembershipEnhancedTable";
import zipcelx from "zipcelx";
import { format } from "date-fns";
import { formatMoney, toStartCase } from "utils/functions";

const DonationReport = () => {
  const {
    currentData, setCurrentData, open, setOpen,
    setSearch, setSearchLevel, setSearchStatus, setSearchCycle,
    updateMyData, skipPageReset, columns, data, pagesize, dataReport, setData,
    current, edit, setEdit, isLoading, totalAmount,
    setDateJoinedFrom, setDateJoinedTo,
    setDonationDateFrom, setDonationDateTo,
  } = useDonationReport();

  const user_level = [
    { id: '', value: 'All', label: 'All' },
    { id: 1, value: 'Member', label: 'Member' },
    { id: 2, value: 'Champion', label: 'Champion' },
    { id: 3, value: 'Patriot', label: 'Patriot' },
  ];

  const donation_cycles = [
    { id: 1, value: 'monthly', label: 'Monthly' },
    { id: 2, value: 'quarterly', label: 'Quarterly' },
    { id: 3, value: 'yearly', label: 'Yearly' },
  ];

  const { page, setPage, allDonors } = useDonationManagement();

  const rows = dataReport?.data?.data?.donation_report || [];

  function getExcel() {
    if (!rows.length) return;

    const headers = [
      { value: 'S/N', type: 'string' },
      { value: 'Date Joined', type: 'string' },
      { value: 'Name', type: 'string' },
      { value: 'Phone Number', type: 'string' },
      { value: 'Amount', type: 'number' },
      { value: 'Donation Date', type: 'string' },
      { value: 'City', type: 'string' },
      { value: 'Level', type: 'string' },
      { value: 'Fundraise', type: 'string' },
    ];

    const dataRows = rows.map((row, index) => [
      { value: index + 1, type: 'number' },
      { value: row?.user?.created_at ? format(new Date(row.user.created_at), 'MMM dd yyyy') : '-', type: 'string' },
      { value: row?.donor_name || '-', type: 'string' },
      { value: row?.donor_phone_number || '-', type: 'string' },
      { value: parseFloat(row?.transaction?.amount || 0), type: 'number' },
      { value: row?.created_at ? format(new Date(row.created_at), 'MMM dd yyyy') : '-', type: 'string' },
      { value: row?.user?.city?.name || '-', type: 'string' },
      { value: row?.user?.category?.name || '-', type: 'string' },
      { value: row?.donation_course?.tagline || '-', type: 'string' },
    ]);

    const summationRow = [
      { value: '', type: 'string' },
      { value: '', type: 'string' },
      { value: '', type: 'string' },
      { value: 'Total Amount', type: 'string' },
      { value: totalAmount, type: 'number' },
      { value: '', type: 'string' },
      { value: '', type: 'string' },
      { value: '', type: 'string' },
      { value: '', type: 'string' },
    ];

    zipcelx({ filename: 'Donation_Report', sheet: { data: [headers, ...dataRows, summationRow] } });
  }

  return (
    <>
      <div className="container-fluid px-4">
        <div className="d-sm-flex align-items-start justify-content-between mt-4">
          <div>
            <h1>Donation Report</h1>
            <ol className="breadcrumb mb-2">
              <li className="breadcrumb-item">Donations</li>
              <li className="breadcrumb-item active">All</li>
            </ol>
          </div>
          <Link className="btn btn-primary mb-2" to={`../${DONATION_ANALYTICS}`} relative="path">View Analytics</Link>
        </div>

        <div className="card mb-4">
          <div className="card-header">
            <i className="fas fa-table me-1"></i>
            Donations
          </div>
          <div className="row px-3 pt-3 pb-2 g-2">
            {/* Global Search */}
            <div className="col-12 col-md-3">
              <input
                type='text'
                placeholder='Global Search Record'
                className="form-control"
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            {/* Level filter */}
            <div className="col-12 col-md-2">
              <SelectBox
                selectName="donation_group"
                selectLabel="Donation category"
                className="form-control"
                isMulti={false}
                itemList={user_level}
                onChange={(e) => setSearchLevel(e.id)}
                selectOption="Select Level"
              />
            </div>

            {/* Cycle filter */}
            <div className="col-12 col-md-2">
              <Select
                className="form-select"
                handleChange={(e) => {
                  const id = JSON.parse(e.target.value)?.value;
                  setSearchCycle(id);
                }}
                options={donation_cycles}
              />
            </div>

            {/* Date Joined filter */}
            <div className="col-12 col-md-4">
              <div className="d-flex align-items-end gap-2">
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">Date Joined From</label>
                  <input
                    type='date'
                    className="form-control"
                    onChange={(e) => setDateJoinedFrom(e.target.value)}
                  />
                </div>
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">To</label>
                  <input
                    type='date'
                    className="form-control"
                    onChange={(e) => setDateJoinedTo(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Donation Date filter */}
            <div className="col-12 col-md-4">
              <div className="d-flex align-items-end gap-2">
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">Donation Date From</label>
                  <input
                    type='date'
                    className="form-control"
                    onChange={(e) => setDonationDateFrom(e.target.value)}
                  />
                </div>
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">To</label>
                  <input
                    type='date'
                    className="form-control"
                    onChange={(e) => setDonationDateTo(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Download Excel */}
            <div className="col-12 col-md-2 d-flex align-items-end">
              <button
                className="btn btn-success w-100"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); getExcel(); }}
              >
                <i className="fas fa-file-excel me-1"></i> Download Excel
              </button>
            </div>
          </div>

          {/* Total Amount Summary */}
          <div className="px-3 pb-2">
            <div className="alert alert-info d-inline-block py-2 px-3 mb-0">
              <strong>Total Amount:</strong> {formatMoney(totalAmount)}
            </div>
          </div>

          <div className="card-body">
            <MembershipEnhancedTable
              columns={columns}
              data={rows}
              setData={setData}
              skipPageReset={skipPageReset}
              currentPage={page}
              setCurrentPage={setPage}
              isFetching={allDonors?.isFetching || allDonors?.isLoading}
            />
          </div>
        </div>
      </div>

      <Modals show={open && current === 'view'}
        onHide={() => setOpen(false)} title='View Donation' size='md'>
        <dl className="striped">
          {currentData && Object.entries(currentData)?.map(([key, value]) =>
            typeof value !== 'string' && typeof value !== 'number' ? [] :
              <div key={key} className='row'>
                <dt className='col-4'>{`${startCase(key)} :`}</dt>
                {(!edit || key === 'id') && <dd className='col-8'>{value}</dd>}
                {edit && key !== 'id' && (
                  <div className="col-8">
                    <input
                      className="form-control"
                      type="text"
                      defaultValue={value}
                      onChange={(e) => setCurrentData({ ...currentData, [key]: e.target.value })}
                    />
                  </div>
                )}
              </div>
          )}
        </dl>
      </Modals>
    </>
  );
}

export default DonationReport;
